import { useQuery } from 'react-query';

import { QUERY_KEYS } from 'consts/queryKeys';
import { getCancellationPoliciesRoot } from 'modules/settings/api';

export const useQueryCancellationPoliciesRoot = () => {
  return useQuery(
    [QUERY_KEYS.SETTINGS_CANCELLATION_POLICIES_ROOT],
    () => getCancellationPoliciesRoot(),
    {
      staleTime: 5 * 60 * 1000,
      keepPreviousData: true,
    },
  );
};
